module.exports = __webpack_public_path__ + "static/shiki-5197962200b6e8b99da3798b013ecabe.jpeg";